import searcherConfig from '@/modules/searcher/config';

searcherConfig.defaultSearcherContentTypes = [
  'article',
  'interview',
  'blogpost',
  'opinion',
  'longform',
];
